<template>
  <v-alert align="center" text color="info">
    <h3 class="text-h5">
      送信しました。<br>
      ご回答有難うございました。
    </h3>
    <div></div>

    <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
    
    <!-- ボタンで指定のURLにリダイレクト -->
    <v-btn align="center" color="info" outlined @click="redirectToExternal">
      トップページへ戻る
    </v-btn>
  </v-alert>
</template>

<script>
export default {
  name: 'Appreciate',
  methods: {
    redirectToExternal() {
      window.location.href = 'https://ssl.japan-reit.com/';
    }
  }
}
</script>
